module.exports = new __parcel__URL__("shop.c1b59597.jpeg").toString();